export const IciTheme = {
  name: 'ici Theme',
  themeId: 'ici',
  colors: {
    brand: {
      primary: {
        100: '#FF6600'
      },
      secondary: {
        100: '#00AAAE'
      }
    }
  },
  fonts: {
    families: {
      text: '"Circular", "Helvetica Neue", "Helvetica", arial, sans-serif',
      condensed: '"Circular", "Helvetica Neue", "Helvetica", arial, sans-serif',
      heading: '"Circular", "Helvetica Neue", "Helvetica", arial, sans-serif',
      subHeading: '"Circular", "Helvetica Neue", "Helvetica", arial, sans-serif'
    }
  }
};